import React from 'react';

import { cssMap } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		paddingBlockStart: token('space.150'),
	},
});

interface StateMessageProps {
	/** URL of the illustration SVG to display. */
	illustrationUrl: string;
	/** The primary heading text to display. */
	title: string;
	/** The secondary descriptive text to display below the title. */
	subtitle: string;
	/** A test ID for the root container element. */
	testId: string;
}

/** Shared layout component for empty, error, and future state messages. */
export const StateMessage = ({
	illustrationUrl,
	title,
	subtitle,
	testId,
}: StateMessageProps): React.JSX.Element => {
	return (
		<Box xcss={styles.container} testId={testId}>
			<Stack space="space.300" alignInline="center">
				<Image src={illustrationUrl} alt="" width={75} height={75} />
				<Stack space="space.100" alignInline="center">
					<Text weight="medium" align="center">
						{title}
					</Text>
					<Text color="color.text.subtlest" align="center">
						{subtitle}
					</Text>
				</Stack>
			</Stack>
		</Box>
	);
};
